export default "__VITE_ASSET__Dvf18RD6__"